<template>
  <div
    id="focus-tutorials"
    class="tutorial-income-rate"
    v-if="showIncomeRateTutorial"
    @click="setShowIncomeRateTutorial"
  >
    <div class="body">
      <div class="has-circle"></div>
      <div class="frame-right">
        <img src="@/assets/icons/Frame.svg" alt="Frame-right" />
      </div>

      <div class="go-back">
        <img
          src="@/assets/icons/ย้อนกลับไปตัวเลือกก่อนหน้า_ คลิกที่นี่.svg"
          alt="go-back"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TutorialIncomeRate",
  mounted() {
    const $tutorial = document.getElementById("focus-tutorials");
    if ($tutorial) {
      window.scroll({
        top: document.getElementById("focus-tutorials").scrollHeight,
        behavior: "smooth",
      });
    }
  },
  data() {
    return {};
  },
  computed: {
    showIncomeRateTutorial() {
      return this.$store.getters["app/getApp"].showIncomeRateTutorial;
    },
  },
  methods: {
    setShowIncomeRateTutorial() {
      this.$store.dispatch("app/addValue", {
        name: "showIncomeRateTutorial",
        value: false,
      });
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.tutorial-income-rate {
  width: 100%;
  height: 100%;
  top: 0px;
  position: absolute;
  top: 0px;
  /* background: rgb(0, 0, 0, 0.9); */

  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
}

.body {
  width: 100%;
  height: 100%;
  position: relative;
}
.frame-right {
  position: absolute;
  top: 670px;
  left: -200px;
  right: 0;
  width: 150px;
  margin: 0px auto;
  z-index: 2;
}
.go-back {
  position: absolute;
  top: 600px;
  left: 0px;
  right: 0;
  width: 100%;
  margin: 50px auto;
  display: flex;
  justify-content: center;
  z-index: 2;
}
.has-circle {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  float: left;
  z-index: 1;
}
.has-circle:after {
  content: " ";
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  width: 150px;
  border-radius: 5px;
  height: 80px;
  box-shadow: 0 0 0 10000px rgba(0, 0, 0, 0.85);
  bottom: 223px;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .has-circle:after {
    bottom: 200px;
  }
}
</style>
